import { DatepickerAvailabilityResultsDay } from './types'

export abstract class DatepickerAvailabilityService {
  abstract get(
    langCode: string,
    slug: string,
    categories?: Array<string>,
    pitchtypeId?: string,
  ): Promise<DatepickerAvailabilityResultsDay[]>
}
